// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.mjs";

function displayAddress(address) {
  return Core__Option.map(address, (function (address) {
                return address.replace(/,.*/, ", Nijmegen");
              }));
}

var carParkUUIDs = [
  "60bf0e76-d3bf-42d1-b7a0-04f0ab048e9d",
  "96ec46a4-8089-49a8-8ca4-df67a5d0bdc1",
  "deb8f7da-0864-4019-8715-53ca185efc42",
  "ffab40f6-4a10-41f2-9cc1-b9c2879d8c37",
  "84af4dc6-992d-40dd-a6e1-a1900ea7961f",
  "8bcc6b34-5273-4b36-9306-4475c60255c2",
  "0967d16d-061b-4f44-838d-36cec4be68b9"
];

function overrideStaticCarData(identifier, data) {
  switch (identifier) {
    case "0967d16d-061b-4f44-838d-36cec4be68b9" :
        return {
                name: "P+R Nijmegen-Noord",
                url: data.url,
                addresses: data.addresses
              };
    case "60bf0e76-d3bf-42d1-b7a0-04f0ab048e9d" :
        return {
                name: "P4 - Molenpoortdak",
                url: data.url,
                addresses: data.addresses
              };
    case "8bcc6b34-5273-4b36-9306-4475c60255c2" :
        return {
                name: "P2 - Oude Stad",
                url: data.url,
                addresses: [{
                    streetName: "Nieuwe Hezelpoort",
                    houseNumber: "1",
                    zipcode: "6541 MG",
                    city: "Nijmegen",
                    country: "Nederland"
                  }]
              };
    case "ffab40f6-4a10-41f2-9cc1-b9c2879d8c37" :
        return {
                name: "P3 - Kelfkensbos",
                url: data.url,
                addresses: data.addresses
              };
    default:
      return data;
  }
}

var organisation = "nijmegen";

var upperSuffix = " Hoog";

var lowerSuffix = " Laag";

var fullThreshold = 5;

var bikeWebsite = "https://www.nijmegen.nl/diensten/parkeren-verkeer-en-vervoer/fiets-stallen/";

export {
  organisation ,
  upperSuffix ,
  lowerSuffix ,
  fullThreshold ,
  displayAddress ,
  bikeWebsite ,
  carParkUUIDs ,
  overrideStaticCarData ,
}
/* No side effect */
